import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "gs-shell"
};
const _hoisted_2 = {
  class: "gs-grid"
};
const _hoisted_3 = {
  class: "gs-card gs-card--full",
  style: {
    "--accent": "#3b82f6"
  }
};
const _hoisted_4 = {
  class: "gs-card__head"
};
const _hoisted_5 = {
  class: "gs-card__time"
};
const _hoisted_6 = {
  key: 0,
  class: "gs-thermo gs-thermo--skeleton"
};
const _hoisted_7 = {
  key: 1,
  class: "gs-thermo--err"
};
const _hoisted_8 = {
  key: 2,
  class: "gs-thermo"
};
const _hoisted_9 = {
  class: "gs-thermo__head"
};
const _hoisted_10 = {
  class: "gs-thermo__label"
};
const _hoisted_11 = {
  class: "gs-thermo__days"
};
const _hoisted_12 = {
  class: "gs-r028"
};
const _hoisted_13 = {
  key: 0,
  class: "gs-r028__err"
};
const _hoisted_14 = {
  key: 1,
  class: "gs-r028__loading"
};
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = {
  class: "gs-r028__kpis"
};
const _hoisted_17 = {
  class: "gs-r028__kpi"
};
const _hoisted_18 = {
  class: "gs-r028__kpi"
};
const _hoisted_19 = {
  class: "gs-r028__kpi-val"
};
const _hoisted_20 = {
  class: "gs-r028__kpi-sub"
};
const _hoisted_21 = {
  class: "gs-r028__kpi"
};
const _hoisted_22 = {
  class: "gs-r028__kpi-val"
};
const _hoisted_23 = {
  class: "gs-r028__kpi-sub"
};
const _hoisted_24 = {
  class: "gs-r028__kpi"
};
const _hoisted_25 = {
  class: "gs-r028__kpi-val"
};
const _hoisted_26 = {
  class: "gs-r028__kpi"
};
const _hoisted_27 = {
  class: "gs-r028__trend"
};
const _hoisted_28 = {
  class: "gs-r028__chart"
};
const _hoisted_29 = ["viewBox"];
const _hoisted_30 = {
  id: "r028MainFill",
  x1: "0",
  y1: "0",
  x2: "0",
  y2: "1"
};
const _hoisted_31 = ["stop-color"];
const _hoisted_32 = ["stop-color"];
const _hoisted_33 = {
  id: "r028MainStroke",
  x1: "0",
  y1: "0",
  x2: "1",
  y2: "0"
};
const _hoisted_34 = ["stop-color"];
const _hoisted_35 = ["stop-color"];
const _hoisted_36 = {
  stroke: "#e2e8f0",
  "stroke-width": "1",
  "stroke-dasharray": "2 3"
};
const _hoisted_37 = ["y1", "y2"];
const _hoisted_38 = ["x", "y"];
const _hoisted_39 = ["x", "y"];
const _hoisted_40 = ["x1", "x2"];
const _hoisted_41 = ["x1", "x2", "y2", "stroke"];
const _hoisted_42 = ["x", "y", "fill"];
const _hoisted_43 = ["d", "opacity"];
const _hoisted_44 = ["points", "stroke", "opacity"];
const _hoisted_45 = {
  key: 'main'
};
const _hoisted_46 = ["points"];
const _hoisted_47 = {
  key: 0
};
const _hoisted_48 = ["cx", "cy", "fill"];
const _hoisted_49 = ["cx", "cy", "fill"];
const _hoisted_50 = ["x", "y", "fill"];
const _hoisted_51 = ["x", "y"];
const _hoisted_52 = {
  key: 3
};
const _hoisted_53 = ["points"];
const _hoisted_54 = {
  key: 4
};
const _hoisted_55 = ["cx", "cy", "fill", "stroke"];
const _hoisted_56 = {
  key: 5,
  filter: "url(#r028Shadow)"
};
const _hoisted_57 = ["x", "y", "width", "height"];
const _hoisted_58 = ["x", "y"];
const _hoisted_59 = ["x", "y"];
const _hoisted_60 = ["x1", "y1", "x2", "y2"];
const _hoisted_61 = ["x", "y", "fill"];
const _hoisted_62 = ["x", "y", "font-weight", "fill"];
const _hoisted_63 = ["x", "y", "font-weight", "fill"];
const _hoisted_64 = {
  class: "gs-r028__legend"
};
const _hoisted_65 = ["onClick", "title"];
const _hoisted_66 = {
  class: "gs-r028__leg-name"
};
const _hoisted_67 = {
  class: "gs-r028__leg-val"
};
const _hoisted_68 = ["title"];
const _hoisted_69 = {
  class: "gs-r028__leg-val"
};
const _hoisted_70 = {
  class: "gs-card__head"
};
const _hoisted_71 = {
  class: "gs-card__head-main"
};
const _hoisted_72 = {
  class: "gs-card__title"
};
const _hoisted_73 = {
  class: "gs-card__title-sub"
};
const _hoisted_74 = {
  class: "gs-card__count-badge"
};
const _hoisted_75 = {
  class: "gs-tags"
};
const _hoisted_76 = ["onClick"];
const _hoisted_77 = {
  class: "gs-stocks"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = {
  class: "gs-stock__name"
};
const _hoisted_80 = {
  class: "gs-stock__code"
};
const _hoisted_81 = {
  class: "gs-stock__price"
};
const _hoisted_82 = {
  class: "gs-stock__form"
};
const _hoisted_83 = {
  class: "gs-card__foot"
};
const _hoisted_84 = {
  class: "gs-drawer__hd"
};
const _hoisted_85 = {
  class: "gs-drawer__name"
};
const _hoisted_86 = {
  class: "gs-drawer__code"
};
const _hoisted_87 = {
  class: "gs-drawer__bd"
};
const _hoisted_88 = {
  class: "gs-drawer__price"
};
const _hoisted_89 = {
  class: "gs-drawer__match"
};
const _hoisted_90 = {
  class: "gs-drawer__signal"
};
const _hoisted_91 = {
  class: "gs-drawer__plan"
};
const _hoisted_92 = {
  class: "gs-drawer__plan-row"
};
const _hoisted_93 = {
  class: "gs-drawer__plan-row"
};
const _hoisted_94 = {
  class: "gs-down"
};
const _hoisted_95 = {
  class: "gs-drawer__plan-row"
};
const _hoisted_96 = {
  class: "gs-up"
};
const _hoisted_97 = {
  class: "gs-drawer__kline"
};
const _hoisted_98 = {
  class: "gs-drawer__candles"
};
const _hoisted_99 = {
  class: "gs-drawer__basis"
};
const _hoisted_100 = ["innerHTML"];
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';

// ========== 质押式回购利率 API ==========
// 数据源：/server-api/repo-thermo（Node.js 端 fetch CWAP，避免 CORS / 代理问题）
// API 完整返回 8 个品种：R001 / R007 / R014 / R021 / R1M / R2M / R3M / R4M
const REPO_LINE_MAIN = 'R1M'; // 重点品种, 加粗 + 渐变面积
const SVG_W = 1160,
  SVG_H = 320;
const PLOT_X0 = 50,
  PLOT_X1 = 1140; // 留 50 / 20 边距
const PLOT_Y0 = 16,
  PLOT_Y1 = 290; // 顶部 16, 底部 290 (下面 30 留给 x 轴)
const INDEX_COLOR = '#0f172a';
export default {
  __name: 'Guanshi',
  setup(__props) {
    const repoData = ref({}); // instrmntCd -> record（按品种索引，供温度计用）
    const repoRecords = ref([]); // 完整 records 数组（按 API 原始顺序）
    const repoUpdate = ref(''); // 2026-07-10 06:58:15
    const repoProvider = ref('CWAP');
    const repoLastDate = ref('');
    const repoErr = ref('');

    // 格式化：成交笔数（千分位整数）
    function formatNum(v) {
      if (v === null || v === undefined || v === '' || v === '---') return '--';
      const n = parseFloat(v);
      if (Number.isNaN(n)) return '--';
      return Math.round(n).toLocaleString('en-US');
    }
    // 格式化：成交量（API 单位亿元，保留 2 位小数）
    function formatTrdVol(v) {
      if (v === null || v === undefined || v === '' || v === '---') return '--';
      const n = parseFloat(v);
      if (Number.isNaN(n)) return '--';
      return n.toFixed(2);
    }
    function fmtRate(v) {
      if (v === null || v === undefined || v === '' || v === '---') return '--';
      const n = parseFloat(v);
      if (Number.isNaN(n)) return '--';
      return n.toFixed(2) + '%';
    }
    function fmtDiff(open, close) {
      if (open === '' || open === '---' || close === '' || close === '---') return '--';
      const o = parseFloat(open),
        c = parseFloat(close);
      if (Number.isNaN(o) || Number.isNaN(c)) return '--';
      const diff = c - o;
      if (Math.abs(diff) < 0.0001) return '0.00%';
      return (diff > 0 ? '+' : '') + diff.toFixed(2) + '%';
    }

    // 温度计项：完整遍历 API 返回的 8 个品种（不再有白名单）
    // 包含：加权平均利率(主)、开盘、收盘、拆借利率、笔数、成交量
    const thermoItems = computed(() => repoRecords.value.map(r => {
      const open = parseFloat(r.openRepoRate);
      const avg = parseFloat(r.wghtdAvgRepoRate);
      const diff = Number.isFinite(open) && Number.isFinite(avg) ? avg - open : 0;
      return {
        code: r.instrmntCd,
        days: r.avgPrd,
        value: fmtRate(r.wghtdAvgRepoRate),
        arrow: diff > 0 ? '↑' : diff < 0 ? '↓' : '─',
        diff: fmtDiff(r.openRepoRate, r.wghtdAvgRepoRate),
        dirClass: diff > 0 ? 'gs-up' : diff < 0 ? 'gs-down' : 'gs-flat',
        // 完整 API 字段
        open: fmtRate(r.openRepoRate),
        // 开盘利率
        close: fmtRate(r.clsngRepoRate),
        // 收盘利率
        debt: fmtRate(r.wghtdAvgRepoDebtRate),
        // 拆借利率
        deals: formatNum(r.dlNo),
        // 成交笔数
        vol: formatTrdVol(r.trdVol) // 成交量(亿元)
      };
    }));
    const repoUpdateTime = computed(() => repoUpdate.value);
    async function fetchRepo() {
      try {
        const resp = await fetch('/server-api/repo-thermo');
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        const json = await resp.json();
        if (json.error) throw new Error(json.error);
        if (!Array.isArray(json.records)) throw new Error('records 字段缺失');
        repoRecords.value = json.records;
        const map = {};
        json.records.forEach(r => {
          map[r.instrmntCd] = r;
        });
        repoData.value = map;
        repoUpdate.value = json.update_time || json.lastDate || '';
        repoProvider.value = json.provider || 'CWAP';
        repoLastDate.value = json.lastDate || '';
        repoErr.value = '';
      } catch (e) {
        repoErr.value = String(e.message || e);
        console.error('[Guanshi] fetchRepo failed:', e);
      }
    }

    // ========== 章节配置 ==========
    const chapters = [{
      id: 'ch2',
      number: '第二章',
      title: '主力建仓',
      subtitle: '底部买入信号',
      accent: '#f59e0b',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: '底部首次涨停',
        type: 'buy'
      }, {
        label: '底部七连阳',
        type: 'buy'
      }, {
        label: '低位复合连阳',
        type: 'buy'
      }, {
        label: '底部宝剑试盘',
        type: 'neutral'
      }]
    }, {
      id: 'ch3',
      number: '第三章',
      title: '庄家震仓',
      subtitle: '洗盘识别与应对',
      accent: '#64748b',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: 'K线鬼脸',
        type: 'warn'
      }, {
        label: '连续小阴线',
        type: 'warn'
      }, {
        label: '抢庄换筹',
        type: 'warn'
      }, {
        label: '量能对称',
        type: 'warn'
      }]
    }, {
      id: 'ch4',
      number: '第四章',
      title: '拉升控盘',
      subtitle: '拉升启动与跟随',
      accent: '#10b981',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: '尾盘打压',
        type: 'buy'
      }, {
        label: '明修双头',
        type: 'buy'
      }, {
        label: '主力配股',
        type: 'buy'
      }, {
        label: '长庄控盘',
        type: 'buy'
      }]
    }, {
      id: 'ch5',
      number: '第五章',
      title: '逃顶',
      subtitle: '顶部卖出信号',
      accent: '#ef4444',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: '尾盘急拉',
        type: 'sell'
      }, {
        label: '单日巨量长阳',
        type: 'sell'
      }, {
        label: '跳高长阴',
        type: 'sell'
      }, {
        label: '高位七连阳',
        type: 'sell'
      }, {
        label: '周K长上影',
        type: 'sell'
      }, {
        label: '大单托盘',
        type: 'sell'
      }, {
        label: '假双底/圆弧顶',
        type: 'neutral'
      }]
    }, {
      id: 'ch6',
      number: '第六章',
      title: '涨停板',
      subtitle: '涨停研判与应对',
      accent: '#8b5cf6',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: '强者恒强',
        type: 'buy'
      }, {
        label: '强弱交替',
        type: 'warn'
      }, {
        label: '力不从心',
        type: 'sell'
      }]
    }, {
      id: 'ch7',
      number: '第七章',
      title: '均线',
      subtitle: '均线波段操作',
      accent: '#0ea5e9',
      tags: [{
        label: '全部',
        type: 'all'
      }, {
        label: '波段操作',
        type: 'buy'
      }, {
        label: '四季均线',
        type: 'buy'
      }, {
        label: '10日套利',
        type: 'neutral'
      }]
    }];

    // ========== 筛选状态 ==========
    const activeTag = ref({
      ch2: '全部',
      ch3: '全部',
      ch4: '全部',
      ch5: '全部',
      ch6: '全部',
      ch7: '全部'
    });

    // ========== 股票数据 ==========
    const stockData = {
      ch2: [{
        name: '华创云信',
        code: '600155',
        price: '12.45',
        change: '+5.2%',
        dir: 'up',
        form: '底部首次涨停',
        match: '95',
        dot: 'd-up'
      }, {
        name: '中科曙光',
        code: '603019',
        price: '38.20',
        change: '+3.1%',
        dir: 'up',
        form: '底部七连阳',
        match: '88',
        dot: 'd-up'
      }, {
        name: '宁德时代',
        code: '300750',
        price: '189.50',
        change: '+1.8%',
        dir: 'up',
        form: '低位复合连阳',
        match: '91',
        dot: 'd-up'
      }, {
        name: '韦尔股份',
        code: '603501',
        price: '105.30',
        change: '+4.2%',
        dir: 'up',
        form: '底部首次涨停',
        match: '93',
        dot: 'd-up'
      }, {
        name: '北方华创',
        code: '002371',
        price: '312.00',
        change: '+2.6%',
        dir: 'up',
        form: '低位复合连阳',
        match: '89',
        dot: 'd-up'
      }, {
        name: '阳光电源',
        code: '300274',
        price: '112.80',
        change: '+1.9%',
        dir: 'up',
        form: '底部七连阳',
        match: '85',
        dot: 'd-up'
      }, {
        name: '赣锋锂业',
        code: '002460',
        price: '42.60',
        change: '+3.5%',
        dir: 'up',
        form: '底部首次涨停',
        match: '82',
        dot: 'd-up'
      }, {
        name: '药明康德',
        code: '603259',
        price: '68.50',
        change: '-0.8%',
        dir: 'down',
        form: '底部宝剑试盘',
        match: '78',
        dot: 'd-neutral'
      }, {
        name: '金山办公',
        code: '688111',
        price: '285.00',
        change: '+1.1%',
        dir: 'up',
        form: '底部七连阳',
        match: '75',
        dot: 'd-up'
      }, {
        name: '兆易创新',
        code: '603986',
        price: '86.20',
        change: '+0.5%',
        dir: 'up',
        form: '低位复合连阳',
        match: '72',
        dot: 'd-up'
      }],
      ch3: [{
        name: '三一重工',
        code: '600031',
        price: '16.82',
        change: '-1.2%',
        dir: 'down',
        form: 'K线鬼脸',
        match: '86',
        dot: 'd-warn'
      }, {
        name: '海康威视',
        code: '002415',
        price: '33.15',
        change: '-0.8%',
        dir: 'down',
        form: '连续小阴线',
        match: '83',
        dot: 'd-warn'
      }, {
        name: '中芯国际',
        code: '688981',
        price: '52.40',
        change: '+6.8%',
        dir: 'up',
        form: '抢庄换筹',
        match: '78',
        dot: 'd-warn'
      }, {
        name: '比亚迪',
        code: '002594',
        price: '268.50',
        change: '-0.5%',
        dir: 'down',
        form: 'K线鬼脸',
        match: '72',
        dot: 'd-warn'
      }, {
        name: '迈瑞医疗',
        code: '300760',
        price: '312.50',
        change: '+0.3%',
        dir: 'up',
        form: '量能对称',
        match: '70',
        dot: 'd-warn'
      }, {
        name: '立讯精密',
        code: '002475',
        price: '32.80',
        change: '-1.5%',
        dir: 'down',
        form: '连续小阴线',
        match: '68',
        dot: 'd-warn'
      }, {
        name: '紫金矿业',
        code: '601899',
        price: '16.82',
        change: '+2.1%',
        dir: 'up',
        form: '抢庄换筹',
        match: '65',
        dot: 'd-warn'
      }, {
        name: '恒生电子',
        code: '600570',
        price: '28.90',
        change: '-0.6%',
        dir: 'down',
        form: 'K线鬼脸',
        match: '62',
        dot: 'd-warn'
      }, {
        name: '天齐锂业',
        code: '002466',
        price: '58.20',
        change: '-2.0%',
        dir: 'down',
        form: '量能对称',
        match: '60',
        dot: 'd-warn'
      }, {
        name: '通威股份',
        code: '600438',
        price: '32.15',
        change: '+0.4%',
        dir: 'up',
        form: '连续小阴线',
        match: '58',
        dot: 'd-warn'
      }],
      ch4: [{
        name: '比亚迪',
        code: '002594',
        price: '268.50',
        change: '+1.2%',
        dir: 'up',
        form: '长庄控盘',
        match: '92',
        dot: 'd-up'
      }, {
        name: '中兴通讯',
        code: '000063',
        price: '28.60',
        change: '-2.1%',
        dir: 'down',
        form: '尾盘打压',
        match: '85',
        dot: 'd-up'
      }, {
        name: '隆基绿能',
        code: '601012',
        price: '21.35',
        change: '+0.8%',
        dir: 'up',
        form: '明修双头',
        match: '80',
        dot: 'd-up'
      }, {
        name: '贵州茅台',
        code: '600519',
        price: '1,580',
        change: '+0.3%',
        dir: 'up',
        form: '长庄控盘',
        match: '76',
        dot: 'd-up'
      }, {
        name: '美的集团',
        code: '000333',
        price: '68.20',
        change: '+1.5%',
        dir: 'up',
        form: '主力配股',
        match: '74',
        dot: 'd-up'
      }, {
        name: '海尔智家',
        code: '600690',
        price: '26.80',
        change: '+0.9%',
        dir: 'up',
        form: '明修双头',
        match: '71',
        dot: 'd-up'
      }, {
        name: '泸州老窖',
        code: '000568',
        price: '185.00',
        change: '+0.6%',
        dir: 'up',
        form: '长庄控盘',
        match: '68',
        dot: 'd-up'
      }, {
        name: '中航沈飞',
        code: '600760',
        price: '42.50',
        change: '-0.7%',
        dir: 'down',
        form: '尾盘打压',
        match: '65',
        dot: 'd-up'
      }, {
        name: '伊利股份',
        code: '600887',
        price: '29.80',
        change: '+0.2%',
        dir: 'up',
        form: '主力配股',
        match: '63',
        dot: 'd-up'
      }, {
        name: '中国核电',
        code: '601985',
        price: '9.85',
        change: '+0.1%',
        dir: 'up',
        form: '长庄控盘',
        match: '61',
        dot: 'd-up'
      }],
      ch5: [{
        name: '贵州茅台',
        code: '600519',
        price: '1,580',
        change: '+2.8%',
        dir: 'up',
        form: '尾盘急拉',
        match: '90',
        dot: 'd-down'
      }, {
        name: '恒瑞医药',
        code: '600276',
        price: '48.50',
        change: '+7.5%',
        dir: 'up',
        form: '单日巨量长阳',
        match: '87',
        dot: 'd-down'
      }, {
        name: '中信证券',
        code: '600030',
        price: '28.40',
        change: '-4.2%',
        dir: 'down',
        form: '跳高长阴',
        match: '84',
        dot: 'd-down'
      }, {
        name: '中国平安',
        code: '601318',
        price: '42.80',
        change: '-3.5%',
        dir: 'down',
        form: '高位七连阳',
        match: '81',
        dot: 'd-down'
      }, {
        name: '五粮液',
        code: '000858',
        price: '158.00',
        change: '+4.2%',
        dir: 'up',
        form: '周K长上影',
        match: '79',
        dot: 'd-down'
      }, {
        name: '东方财富',
        code: '300059',
        price: '25.60',
        change: '+10.0%',
        dir: 'up',
        form: '大单托盘',
        match: '77',
        dot: 'd-down'
      }, {
        name: '长江电力',
        code: '600900',
        price: '22.80',
        change: '+0.4%',
        dir: 'up',
        form: '假双底/圆弧顶',
        match: '74',
        dot: 'd-down'
      }, {
        name: '同花顺',
        code: '300033',
        price: '196.50',
        change: '+5.8%',
        dir: 'up',
        form: '单日巨量长阳',
        match: '72',
        dot: 'd-down'
      }, {
        name: '工业富联',
        code: '601138',
        price: '22.50',
        change: '-2.5%',
        dir: 'down',
        form: '跳高长阴',
        match: '69',
        dot: 'd-down'
      }, {
        name: '万华化学',
        code: '600309',
        price: '82.30',
        change: '+1.6%',
        dir: 'up',
        form: '高位七连阳',
        match: '66',
        dot: 'd-down'
      }],
      ch6: [{
        name: '东方财富',
        code: '300059',
        price: '25.60',
        change: '+10.0%',
        dir: 'up',
        form: '强者恒强',
        match: '96',
        dot: 'd-up'
      }, {
        name: '同花顺',
        code: '300033',
        price: '196.50',
        change: '+5.8%',
        dir: 'up',
        form: '强者恒强',
        match: '91',
        dot: 'd-up'
      }, {
        name: '隆基绿能',
        code: '601012',
        price: '21.35',
        change: '+0.8%',
        dir: 'up',
        form: '强弱交替',
        match: '80',
        dot: 'd-warn'
      }, {
        name: '中国平安',
        code: '601318',
        price: '42.80',
        change: '-3.5%',
        dir: 'down',
        form: '力不从心',
        match: '88',
        dot: 'd-down'
      }, {
        name: '中信证券',
        code: '600030',
        price: '28.40',
        change: '+9.8%',
        dir: 'up',
        form: '强者恒强',
        match: '93',
        dot: 'd-up'
      }, {
        name: '中科曙光',
        code: '603019',
        price: '38.20',
        change: '+3.1%',
        dir: 'up',
        form: '强弱交替',
        match: '85',
        dot: 'd-warn'
      }, {
        name: '万科A',
        code: '000002',
        price: '15.60',
        change: '-2.3%',
        dir: 'down',
        form: '力不从心',
        match: '82',
        dot: 'd-down'
      }, {
        name: '华创云信',
        code: '600155',
        price: '12.45',
        change: '+10.0%',
        dir: 'up',
        form: '强者恒强',
        match: '90',
        dot: 'd-up'
      }, {
        name: '宁德时代',
        code: '300750',
        price: '189.50',
        change: '-1.2%',
        dir: 'down',
        form: '力不从心',
        match: '78',
        dot: 'd-down'
      }, {
        name: '三一重工',
        code: '600031',
        price: '16.82',
        change: '+0.6%',
        dir: 'up',
        form: '强弱交替',
        match: '74',
        dot: 'd-warn'
      }],
      ch7: [{
        name: '招商银行',
        code: '600036',
        price: '35.20',
        change: '+1.2%',
        dir: 'up',
        form: '四季均线',
        match: '94',
        dot: 'd-up'
      }, {
        name: '长江电力',
        code: '600900',
        price: '22.80',
        change: '+0.4%',
        dir: 'up',
        form: '波段操作',
        match: '91',
        dot: 'd-up'
      }, {
        name: '中国神华',
        code: '601088',
        price: '38.50',
        change: '+0.8%',
        dir: 'up',
        form: '四季均线',
        match: '87',
        dot: 'd-up'
      }, {
        name: '中信证券',
        code: '600030',
        price: '28.40',
        change: '-4.2%',
        dir: 'down',
        form: '10日套利',
        match: '81',
        dot: 'd-down'
      }, {
        name: '工商银行',
        code: '601398',
        price: '5.60',
        change: '+0.2%',
        dir: 'up',
        form: '四季均线',
        match: '86',
        dot: 'd-up'
      }, {
        name: '中国石油',
        code: '601857',
        price: '8.92',
        change: '+0.3%',
        dir: 'up',
        form: '波段操作',
        match: '83',
        dot: 'd-up'
      }, {
        name: '海螺水泥',
        code: '600585',
        price: '24.50',
        change: '-0.9%',
        dir: 'down',
        form: '10日套利',
        match: '79',
        dot: 'd-down'
      }, {
        name: '中国移动',
        code: '600941',
        price: '98.50',
        change: '+0.5%',
        dir: 'up',
        form: '四季均线',
        match: '76',
        dot: 'd-up'
      }, {
        name: '宝钢股份',
        code: '600019',
        price: '6.85',
        change: '-1.2%',
        dir: 'down',
        form: '10日套利',
        match: '73',
        dot: 'd-neutral'
      }, {
        name: '中国银行',
        code: '601988',
        price: '3.92',
        change: '+0.1%',
        dir: 'up',
        form: '波段操作',
        match: '70',
        dot: 'd-up'
      }]
    };

    // ========== 筛选逻辑 ==========
    function filteredStocks(chapter) {
      const tag = activeTag.value[chapter];
      const stocks = stockData[chapter];
      if (tag === '全部') return stocks;
      return stocks.filter(s => s.form === tag || s.form.startsWith(tag));
    }

    // ========== 抽屉 ==========
    const drawerOpen = ref(false);
    const drawerData = ref({
      name: '华创云信',
      code: '600155',
      price: '12.45',
      change: '+5.2%',
      direction: 'up',
      signal: '底部首次涨停',
      match: '95'
    });
    const drawerBasis = ['前期横盘整理<strong>&ge;1个月</strong>，跌幅已深', '涨停当日<strong>温和放量</strong>，量比1.5-3倍', '封板时间<strong>上午10:30前</strong>，封单坚决', '股价处于<strong>底部区域</strong>，非高位', '涨停后<strong>缩量回调</strong>不跌破涨停价', '量价关系：<strong>量增价涨</strong>，理想配合'];
    const candleTypes = [{
      cls: 'down',
      body: 18
    }, {
      cls: 'down',
      body: 14
    }, {
      cls: 'up',
      body: 22
    }, {
      cls: 'up',
      body: 30
    }, {
      cls: 'down',
      body: 26
    }, {
      cls: 'down',
      body: 18
    }, {
      cls: 'up',
      body: 36
    }, {
      cls: 'down',
      body: 28
    }, {
      cls: 'up',
      body: 32
    }, {
      cls: 'up',
      body: 42
    }, {
      cls: 'up',
      body: 50
    }, {
      cls: 'up',
      body: 58
    }];
    function openDrawer(name, code, price, change, direction, signal, match) {
      drawerData.value = {
        name,
        code,
        price,
        change,
        direction,
        signal,
        match
      };
      drawerOpen.value = true;
    }
    function closeDrawer() {
      drawerOpen.value = false;
    }
    function handleKeydown(e) {
      if (e.key === 'Escape') closeDrawer();
    }
    let repoTimer = null;
    onMounted(() => {
      document.addEventListener('keydown', handleKeydown);
      fetchRepo();
      fetchChart();
      fetchIndexKline();
      // 质押式回购利率每 60s 自动刷新
      repoTimer = setInterval(fetchRepo, 60 * 1000);
      // 折线图每 5 分钟刷新
      setInterval(fetchChart, 5 * 60 * 1000);
      setInterval(fetchIndexKline, 5 * 60 * 1000);
    });
    onUnmounted(() => {
      document.removeEventListener('keydown', handleKeydown);
      if (repoTimer) clearInterval(repoTimer);
    });

    // ========== 质押式回购利率 8 品种折线图 ==========
    // 调色板: 金融终端风, 偏深, 饱和度统一
    const REPO_LINE_COLORS = {
      R001: '#1d4ed8',
      R007: '#7c3aed',
      R014: '#0891b2',
      R021: '#0d9488',
      R1M: '#ea580c',
      R2M: '#dc2626',
      R4M: '#be185d',
      R9M: '#475569'
    };
    const REPO_LINE_ORDER = ['R001', 'R007', 'R014', 'R021', 'R1M', 'R2M', 'R4M', 'R9M'];
    const mainColor = REPO_LINE_COLORS[REPO_LINE_MAIN];

    // SVG 画布与绘图区
    const PLOT_W = PLOT_X1 - PLOT_X0;
    const PLOT_H = PLOT_Y1 - PLOT_Y0;
    const repoDates = ref([]);
    const repoRates = ref({});
    const chartErr = ref('');
    // 上证指数叠加 (右Y轴)
    const indexDates = ref([]);
    const indexCloses = ref([]);
    const indexLatest = ref('--');
    const indexErr = ref('');
    const hiddenLines = ref({}); // { R001: false, R1M: false ... }
    const hoverIdx = ref(-1);
    const hoverX = ref(0);
    async function fetchChart() {
      try {
        const resp = await fetch('/server-api/repo-lines');
        if (!resp.ok) throw new Error('折线数据 HTTP ' + resp.status);
        const json = await resp.json();
        repoDates.value = json.dates || [];
        repoRates.value = json.lines || {};
        // 默认只显示 3 条: R001 / R007 / R1M, 其余隐藏
        // (首次初始化时执行; 已交互过的列表不强制重置, 避免覆盖用户操作)
        if (!onlyCode.value && Object.keys(hiddenLines.value).length === 0) {
          const init = {};
          REPO_LINE_ORDER.forEach(c => {
            init[c] = !(c === 'R001' || c === 'R007' || c === REPO_LINE_MAIN);
          });
          hiddenLines.value = init;
        }
        chartErr.value = '';
        hoverIdx.value = -1;
      } catch (e) {
        chartErr.value = String(e.message || e);
      }
    }
    async function fetchIndexKline() {
      try {
        const r = await fetch('/server-api/index-kline?symbol=000001.SH&tf=1d&count=10&adjust=qfq');
        if (!r.ok) throw new Error('上证K线 HTTP ' + r.status);
        const json = await r.json();
        if (json.error) throw new Error(json.error);
        indexDates.value = json.dates || [];
        indexCloses.value = json.closes || [];
        const arr = indexCloses.value;
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i] != null && Number.isFinite(arr[i])) {
            indexLatest.value = arr[i].toFixed(2);
            break;
          }
        }
        indexErr.value = '';
      } catch (e) {
        indexErr.value = String(e.message || e);
      }
    }

    // 单击图例: 切换显隐
    // 双击图例: 进入"只显示"模式 (再双击同一图例恢复全部)
    function toggleLine(code) {
      hiddenLines.value[code] = !hiddenLines.value[code];
    }
    const onlyCode = ref(null);
    function soloLine(code) {
      if (onlyCode.value === code) {
        onlyCode.value = null;
        Object.keys(hiddenLines.value).forEach(k => {
          hiddenLines.value[k] = false;
        });
      } else {
        onlyCode.value = code;
        Object.keys(hiddenLines.value).forEach(k => {
          hiddenLines.value[k] = k !== code;
        });
      }
    }
    function onLegClick(code, e) {
      if (e.detail === 2) soloLine(code);else toggleLine(code);
    }

    // 派生: 主线是否唯一显示 (用于图例加 "★ 锁定" 状态)
    const isOnlyMain = computed(() => {
      const visible = REPO_LINE_ORDER.filter(c => repoRates.value[c] && !hiddenLines.value[c]);
      return visible.length === 1 && visible[0] === REPO_LINE_MAIN;
    });
    watch(onlyCode, () => {
      // 锁模式变化 → 已在 soloLine / toggleLine 内同步过 hiddenLines
      // 这里仅触发依赖刷新
    });

    // ============== Y 轴: nice-step 细分 ==============
    // 数据值域 → nice domain (头尾取整到 step) → 6 档 tick
    function niceStep(roughStep) {
      // 0.01 / 0.02 / 0.025 / 0.05 / 0.1 ...
      const candidates = [0.005, 0.01, 0.02, 0.025, 0.05, 0.1, 0.2, 0.5, 1];
      for (const c of candidates) if (c >= roughStep) return c;
      return 1;
    }
    const yAxis = computed(() => {
      const n = repoDates.value.length;
      if (n === 0) return {
        min: 0,
        max: 1,
        step: 0.2,
        ticks: []
      };
      let max = -Infinity,
        min = Infinity;
      Object.values(repoRates.value).forEach(arr => {
        arr.forEach(v => {
          if (v !== null && Number.isFinite(v)) {
            if (v > max) max = v;
            if (v < min) min = v;
          }
        });
      });
      if (max === -Infinity || min === Infinity) return {
        min: 0,
        max: 1,
        step: 0.2,
        ticks: []
      };
      if (max === min) {
        max += 0.01;
        min -= 0.01;
      }
      // 5% padding
      const pad = (max - min) * 0.1;
      min -= pad;
      max += pad;
      // 让 min/max 取整到 step
      const roughStep = (max - min) / 5;
      const step = niceStep(roughStep);
      const niceMin = Math.floor(min / step) * step;
      const niceMax = Math.ceil(max / step) * step;
      // 6 档 (0..5)
      const ticks = [];
      for (let i = 0; i <= 5; i++) {
        const v = niceMin + i * (niceMax - niceMin) / 5;
        const y = PLOT_Y1 - (v - niceMin) / (niceMax - niceMin) * PLOT_H;
        ticks.push({
          y,
          label: v.toFixed(2) + '%'
        });
      }
      return {
        min: niceMin,
        max: niceMax,
        step,
        ticks
      };
    });
    const yAxisTicks = computed(() => yAxis.value.ticks);

    // ============== X 轴: 显示所有日期 ==============
    const xAxisLabels = computed(() => {
      const n = repoDates.value.length;
      if (n === 0) return [];
      const w = PLOT_W / Math.max(1, n - 1);
      return repoDates.value.map((d, i) => {
        const m = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        return {
          i,
          x: PLOT_X0 + i * w,
          label: m ? `${m[2]}/${m[3]}` : ''
        };
      });
    });

    // ============== 折线: 分段绘制, 跳过 null ==============
    function lastValText(values) {
      for (let i = values.length - 1; i >= 0; i--) {
        if (values[i] !== null && Number.isFinite(values[i])) return values[i].toFixed(2) + '%';
      }
      return '--';
    }
    const repoLines = computed(() => {
      const n = repoDates.value.length;
      if (n === 0) return [];
      const w = PLOT_W / Math.max(1, n - 1);
      const {
        min,
        max
      } = yAxis.value;
      function y(v) {
        if (max === min) return PLOT_Y1;
        return PLOT_Y1 - (v - min) / (max - min) * PLOT_H;
      }
      return REPO_LINE_ORDER.filter(code => repoRates.value[code]).map(code => {
        const values = repoRates.value[code];
        // 分段: 连续的非 null 序列
        const segs = [];
        let cur = [];
        values.forEach((v, i) => {
          if (v === null || !Number.isFinite(v)) {
            if (cur.length) {
              segs.push(cur);
              cur = [];
            }
          } else {
            cur.push(`${(PLOT_X0 + i * w).toFixed(1)},${y(v).toFixed(1)}`);
          }
        });
        if (cur.length) segs.push(cur);
        return {
          code,
          color: REPO_LINE_COLORS[code] || '#94a3b8',
          segments: segs,
          isMain: code === REPO_LINE_MAIN,
          hidden: !!hiddenLines.value[code],
          lastText: lastValText(values)
        };
      });
    });

    // ============== hover: 鼠标位置 → 最近日期 index ==============
    function onChartHover(e) {
      const svg = e.currentTarget;
      const pt = svg.createSVGPoint();
      pt.x = e.clientX;
      pt.y = e.clientY;
      const ctm = svg.getScreenCTM();
      if (!ctm) return;
      const local = pt.matrixTransform(ctm.inverse());
      const n = repoDates.value.length;
      if (n === 0) return;
      const w = PLOT_W / Math.max(1, n - 1);
      const idx = Math.max(0, Math.min(n - 1, Math.round((local.x - PLOT_X0) / w)));
      hoverIdx.value = idx;
      hoverX.value = PLOT_X0 + idx * w;
    }

    // hover 圆点 (在 hoverIdx 处的所有品种)
    const hoverDots = computed(() => {
      if (hoverIdx.value < 0) return [];
      return repoLines.value.filter(l => !l.hidden).map(l => {
        var _repoRates$value$l$co;
        const v = (_repoRates$value$l$co = repoRates.value[l.code]) === null || _repoRates$value$l$co === void 0 ? void 0 : _repoRates$value$l$co[hoverIdx.value];
        if (v === null || v === undefined || !Number.isFinite(v)) return null;
        const {
          min,
          max
        } = yAxis.value;
        const y = max === min ? PLOT_Y1 : PLOT_Y1 - (v - min) / (max - min) * PLOT_H;
        return {
          code: l.code,
          color: l.color,
          x: hoverX.value,
          y,
          isMain: l.isMain
        };
      }).filter(Boolean);
    });

    // hover tooltip
    const hoverTip = computed(() => {
      if (hoverIdx.value < 0) return null;
      const rawDate = repoDates.value[hoverIdx.value] || '';
      const m = rawDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const date = m ? `${m[2]}/${m[3]}` : rawDate;
      // 仅显示非 null & 非 hidden 的品种, 按值降序
      const rows = repoLines.value.filter(l => !l.hidden).map(l => {
        var _repoRates$value$l$co2;
        const v = (_repoRates$value$l$co2 = repoRates.value[l.code]) === null || _repoRates$value$l$co2 === void 0 ? void 0 : _repoRates$value$l$co2[hoverIdx.value];
        if (v === null || v === undefined || !Number.isFinite(v)) return null;
        return {
          code: l.code,
          value: v.toFixed(2) + '%',
          color: l.color,
          isMain: l.isMain
        };
      }).filter(Boolean).sort((a, b) => parseFloat(b.value) - parseFloat(a.value));
      if (!rows.length) return null;
      // tooltip 框尺寸 (白底, 阴影, 多行)
      const w = 132;
      const h = 32 + rows.length * 16 + 10;
      // 避免溢出右边界
      let x = hoverX.value + 14;
      if (x + w > PLOT_X1) x = hoverX.value - w - 14;
      let y = 24;
      return {
        x,
        y,
        w,
        h,
        date,
        rows
      };
    });

    // ============== R1M 主线 KPI ==============
    const mainLatest = computed(() => {
      const arr = repoRates.value[REPO_LINE_MAIN] || [];
      let lastIdx = -1;
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i] !== null && Number.isFinite(arr[i])) {
          lastIdx = i;
          break;
        }
      }
      if (lastIdx < 0) return {
        value: '--',
        diff: '--',
        arrow: '─',
        dir: 'flat'
      };
      const last = arr[lastIdx];
      // 找前一个非 null
      let prevIdx = -1;
      for (let i = lastIdx - 1; i >= 0; i--) {
        if (arr[i] !== null && Number.isFinite(arr[i])) {
          prevIdx = i;
          break;
        }
      }
      const prev = prevIdx >= 0 ? arr[prevIdx] : last;
      const diff = last - prev;
      return {
        value: last.toFixed(2),
        diff: (Math.abs(diff) < 0.0001 ? '0.00' : (diff > 0 ? '+' : '') + diff.toFixed(2)) + '%',
        arrow: diff > 0 ? '↑' : diff < 0 ? '↓' : '─',
        dir: diff > 0 ? 'up' : diff < 0 ? 'down' : 'flat'
      };
    });
    const mainDirClass = computed(() => 'gs-' + mainLatest.value.dir);
    const mainStats = computed(() => {
      const arr = (repoRates.value[REPO_LINE_MAIN] || []).filter(v => v !== null && Number.isFinite(v));
      if (!arr.length) return {
        high: '--',
        highDate: '',
        low: '--',
        lowDate: '',
        ma5: '--',
        ma5Dir: '',
        spark: []
      };
      let hi = -Infinity,
        hiIdx = -1,
        lo = Infinity,
        loIdx = -1;
      arr.forEach((v, i) => {
        if (v > hi) {
          hi = v;
          hiIdx = i;
        }
        if (v < lo) {
          lo = v;
          loIdx = i;
        }
      });
      const dates = repoDates.value;
      // 5 日均线: 取 arr 末尾最多 5 个
      const tail = arr.slice(-5);
      const avg = tail.reduce((a, b) => a + b, 0) / tail.length;
      // ma5 vs latest
      const tailDir = avg > arr[arr.length - 1] ? '低于均值' : avg < arr[arr.length - 1] ? '高于均值' : '等于均值';
      // sparkline: 末尾 12 个点
      const tailN = arr.slice(-12);
      const lo2 = Math.min(...tailN),
        hi2 = Math.max(...tailN);
      const range = hi2 - lo2 || 1;
      const spark = tailN.map((v, i) => {
        const h = 14 + (v - lo2) / range * 78;
        return {
          h,
          color: i === 0 ? '#cbd5e1' : v >= tailN[i - 1] ? '#ef4444' : '#22c55e'
        };
      });
      return {
        high: hi.toFixed(2) + '%',
        highDate: dates[hiIdx] ? dates[hiIdx].slice(5).replace('-', '/') : '',
        low: lo.toFixed(2) + '%',
        lowDate: dates[loIdx] ? dates[loIdx].slice(5).replace('-', '/') : '',
        ma5: avg.toFixed(2) + '%',
        ma5Dir: tailDir,
        spark
      };
    });

    // ============== 主线对象 & 端点胶囊 & 下方面积路径 ==============
    const mainLine = computed(() => repoLines.value.find(l => l.code === REPO_LINE_MAIN));
    const mainLineHidden = computed(() => !!(mainLine.value && mainLine.value.hidden));
    const mainEnd = computed(() => {
      if (!mainLine.value) return null;
      const arr = repoRates.value[REPO_LINE_MAIN] || [];
      // 找最右一个非 null
      const n = arr.length;
      if (n === 0) return null;
      let idx = -1,
        v = null;
      for (let i = n - 1; i >= 0; i--) {
        if (arr[i] !== null && Number.isFinite(arr[i])) {
          idx = i;
          v = arr[i];
          break;
        }
      }
      if (idx < 0) return null;
      const w = PLOT_W / Math.max(1, n - 1);
      const {
        min,
        max
      } = yAxis.value;
      const y = max === min ? PLOT_Y1 : PLOT_Y1 - (v - min) / (max - min) * PLOT_H;
      const x = PLOT_X0 + idx * w;
      // 数值胶囊: 右侧 4px, 高度 20
      let tagX = x + 10;
      if (tagX + 62 > PLOT_X1) tagX = x - 72;
      const tagY = Math.max(PLOT_Y0 + 2, Math.min(PLOT_Y1 - 22, y - 10));
      return {
        x,
        y,
        tagX,
        tagY
      };
    });
    const mainAreaPath = computed(() => {
      if (!mainLine.value) return '';
      const arr = repoRates.value[REPO_LINE_MAIN] || [];
      const n = arr.length;
      if (n === 0) return '';
      const w = PLOT_W / Math.max(1, n - 1);
      const {
        min,
        max
      } = yAxis.value;
      // 拼接所有非 null 点
      const pts = [];
      arr.forEach((v, i) => {
        if (v === null || !Number.isFinite(v)) return;
        const x = PLOT_X0 + i * w;
        const y = max === min ? PLOT_Y1 : PLOT_Y1 - (v - min) / (max - min) * PLOT_H;
        pts.push([x, y, i]);
      });
      if (pts.length < 2) return '';
      // 分段生成 path (避免跨越 null)
      const segs = [];
      let cur = [pts[0]];
      for (let i = 1; i < pts.length; i++) {
        if (pts[i][2] === pts[i - 1][2] + 1) cur.push(pts[i]);else {
          segs.push(cur);
          cur = [pts[i]];
        }
      }
      segs.push(cur);
      return segs.map(seg => {
        const first = seg[0],
          last = seg[seg.length - 1];
        const top = seg.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' L ');
        return `M ${first[0].toFixed(1)},${PLOT_Y1} L ${top} L ${last[0].toFixed(1)},${PLOT_Y1} Z`;
      }).join(' ');
    });

    // ============== 上证指数 (右 Y 轴) ==============
    const indexYAxis = computed(() => {
      const c = indexCloses.value.filter(v => v != null && Number.isFinite(v));
      if (!c.length) return {
        ticks: [],
        min: 0,
        max: 1
      };
      let max = Math.max(...c),
        min = Math.min(...c);
      if (max === min) {
        max += 50;
        min -= 50;
      }
      const pad = (max - min) * 0.1;
      min -= pad;
      max += pad;
      const rough = (max - min) / 4;
      const mag = Math.pow(10, Math.floor(Math.log10(rough)));
      let step = mag;
      if (mag * 2 >= rough) step = mag * 2;else if (mag * 2.5 >= rough) step = mag * 2.5;else step = mag * 5;
      const niceMin = Math.floor(min / step) * step;
      const niceMax = Math.ceil(max / step) * step;
      const ticks = [];
      for (let v = niceMin; v <= niceMax + step * 0.01; v += step) {
        const y = PLOT_Y1 - (v - niceMin) / (niceMax - niceMin) * PLOT_H;
        ticks.push({
          y,
          label: v.toFixed(0)
        });
      }
      return {
        ticks,
        min: niceMin,
        max: niceMax
      };
    });
    const indexLineSegments = computed(() => {
      const n = repoDates.value.length;
      if (n === 0 || indexCloses.value.length === 0) return [];
      const w = PLOT_W / Math.max(1, n - 1);
      const {
        min,
        max
      } = indexYAxis.value;
      function y(v) {
        if (max === min) return PLOT_Y1;
        return PLOT_Y1 - (v - min) / (max - min) * PLOT_H;
      }
      // 将 index dates 映射到 repo dates
      const idxMap = {};
      indexDates.value.forEach((d, i) => {
        if (d && indexCloses.value[i] != null) idxMap[d] = i;
      });
      const segs = [],
        cur = [];
      repoDates.value.forEach((rd, ri) => {
        const ii = idxMap[rd];
        if (ii !== undefined) {
          const v = indexCloses.value[ii];
          if (Number.isFinite(v)) {
            cur.push(`${(PLOT_X0 + ri * w).toFixed(1)},${y(v).toFixed(1)}`);
            return;
          }
        }
        if (cur.length >= 2) segs.push(cur.slice());
        cur.length = 0;
      });
      if (cur.length >= 2) segs.push(cur.slice());
      return segs;
    });

    // 单击两次同一品种: 锁住"只显示该品种" (双击可恢复全部)

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "gs-card__head-main"
      }, [_createElementVNode("h3", {
        class: "gs-card__title"
      }, [_createTextVNode("R-028 同步定律 "), _createElementVNode("span", {
        class: "gs-card__title-sub"
      }, "大势研判")]), _createElementVNode("span", {
        class: "gs-card__kicker"
      }, "资金杠杆定律")], -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(repoUpdateTime.value || '加载中…'), 1)]), !repoRecords.value.length && !repoErr.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, n => {
        return _createElementVNode("div", {
          key: 'sk' + n,
          class: "gs-thermo__item gs-skel"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "gs-skel__label"
        }, null, -1), _createElementVNode("div", {
          class: "gs-skel__val"
        }, null, -1)]))]);
      }), 64))])) : repoErr.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", null, "数据加载失败：" + _toDisplayString(repoErr.value), 1), _createElementVNode("button", {
        onClick: fetchRepo
      }, "重试")])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thermoItems.value, r => {
        return _openBlock(), _createElementBlock("div", {
          key: r.code,
          class: "gs-thermo__item"
        }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("em", _hoisted_10, [_createTextVNode(_toDisplayString(r.code) + " ", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(r.days) + "天", 1)]), _createElementVNode("span", {
          class: _normalizeClass(["gs-thermo__chg", r.dirClass])
        }, _toDisplayString(r.arrow) + " " + _toDisplayString(r.diff), 3)]), _createElementVNode("strong", {
          class: _normalizeClass(["gs-thermo__val", r.dirClass])
        }, _toDisplayString(r.value), 3)]);
      }), 128))])), _createElementVNode("div", _hoisted_12, [chartErr.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createTextVNode(" 走势图加载失败：" + _toDisplayString(chartErr.value) + " ", 1), _createElementVNode("button", {
        onClick: fetchChart
      }, "重试")])) : !repoDates.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, "走势图加载中…")) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "gs-r028__kpi-label"
      }, "R1M 最新", -1)), _createElementVNode("strong", {
        class: _normalizeClass(["gs-r028__kpi-val", mainDirClass.value])
      }, [_createTextVNode(_toDisplayString(mainLatest.value.value), 1), _cache[3] || (_cache[3] = _createElementVNode("i", null, "%", -1))], 2), _createElementVNode("span", {
        class: _normalizeClass(["gs-r028__kpi-delta", mainDirClass.value])
      }, _toDisplayString(mainLatest.value.arrow) + " " + _toDisplayString(mainLatest.value.diff), 3)]), _createElementVNode("div", _hoisted_18, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "gs-r028__kpi-label"
      }, "区间最高", -1)), _createElementVNode("strong", _hoisted_19, _toDisplayString(mainStats.value.high), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(mainStats.value.highDate), 1)]), _createElementVNode("div", _hoisted_21, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "gs-r028__kpi-label"
      }, "区间最低", -1)), _createElementVNode("strong", _hoisted_22, _toDisplayString(mainStats.value.low), 1), _createElementVNode("span", _hoisted_23, _toDisplayString(mainStats.value.lowDate), 1)]), _createElementVNode("div", _hoisted_24, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "gs-r028__kpi-label"
      }, "5日均值", -1)), _createElementVNode("strong", _hoisted_25, _toDisplayString(mainStats.value.ma5), 1), _createElementVNode("span", {
        class: _normalizeClass(["gs-r028__kpi-sub", mainDirClass.value])
      }, _toDisplayString(mainStats.value.ma5Dir), 3)]), _createElementVNode("div", _hoisted_26, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "gs-r028__kpi-label"
      }, "区间趋势", -1)), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainStats.value.spark, (c, ci) => {
        return _openBlock(), _createElementBlock("span", {
          key: 'sp' + ci,
          class: "gs-r028__trend-bar",
          style: _normalizeStyle({
            height: c.h + '%',
            background: c.color
          })
        }, null, 4);
      }), 128))])])]), _createElementVNode("div", _hoisted_28, [(_openBlock(), _createElementBlock("svg", {
        viewBox: `0 0 ${SVG_W} ${SVG_H}`,
        class: "gs-r028__svg",
        onMousemove: onChartHover,
        onMouseleave: _cache[0] || (_cache[0] = $event => hoverIdx.value = -1)
      }, [_createElementVNode("defs", null, [_cache[9] || (_cache[9] = _createElementVNode("linearGradient", {
        id: "r028Bg",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "1"
      }, [_createElementVNode("stop", {
        offset: "0%",
        "stop-color": "#f8fafc"
      }), _createElementVNode("stop", {
        offset: "100%",
        "stop-color": "#eef2f7"
      })], -1)), _createElementVNode("linearGradient", _hoisted_30, [_createElementVNode("stop", {
        offset: "0%",
        "stop-color": _unref(mainColor),
        "stop-opacity": "0.28"
      }, null, 8, _hoisted_31), _createElementVNode("stop", {
        offset: "100%",
        "stop-color": _unref(mainColor),
        "stop-opacity": "0"
      }, null, 8, _hoisted_32)]), _createElementVNode("linearGradient", _hoisted_33, [_createElementVNode("stop", {
        offset: "0%",
        "stop-color": _unref(mainColor),
        "stop-opacity": "0.55"
      }, null, 8, _hoisted_34), _createElementVNode("stop", {
        offset: "100%",
        "stop-color": _unref(mainColor),
        "stop-opacity": "1"
      }, null, 8, _hoisted_35)]), _cache[10] || (_cache[10] = _createElementVNode("filter", {
        id: "r028Shadow",
        x: "-50%",
        y: "-50%",
        width: "200%",
        height: "200%"
      }, [_createElementVNode("feDropShadow", {
        dx: "0",
        dy: "2",
        stdDeviation: "6",
        "flood-color": "#0f172a",
        "flood-opacity": "0.18"
      })], -1))]), _createElementVNode("rect", {
        x: PLOT_X0,
        y: PLOT_Y0,
        width: PLOT_W,
        height: PLOT_H,
        fill: "url(#r028Bg)",
        rx: "4"
      }), _createElementVNode("g", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yAxisTicks.value, t => {
        return _openBlock(), _createElementBlock("line", {
          key: 'g' + t.y,
          x1: PLOT_X0,
          y1: t.y,
          x2: PLOT_X1,
          y2: t.y
        }, null, 8, _hoisted_37);
      }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yAxisTicks.value, t => {
        return _openBlock(), _createElementBlock("text", {
          key: 'yt' + t.y,
          x: PLOT_X0 - 10,
          y: t.y + 3,
          "font-size": "10",
          fill: "#94a3b8",
          "text-anchor": "end",
          "font-variant-numeric": "tabular-nums"
        }, _toDisplayString(t.label), 9, _hoisted_38);
      }), 128)), indexYAxis.value.ticks.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(indexYAxis.value.ticks, t => {
        return _openBlock(), _createElementBlock("text", {
          key: 'iyt' + t.y,
          x: PLOT_X1 + 14,
          y: t.y + 3,
          "font-size": "10",
          fill: "#64748b",
          "text-anchor": "start",
          "font-variant-numeric": "tabular-nums",
          "font-weight": "500"
        }, _toDisplayString(t.label), 9, _hoisted_39);
      }), 128)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xAxisLabels.value, d => {
        return _openBlock(), _createElementBlock("g", {
          key: 'xd' + d.i
        }, [d.i === hoverIdx.value ? (_openBlock(), _createElementBlock("line", {
          key: 0,
          x1: d.x,
          y1: PLOT_Y0,
          x2: d.x,
          y2: PLOT_Y1,
          stroke: "#cbd5e1",
          "stroke-width": "1",
          "stroke-dasharray": "3 3"
        }, null, 8, _hoisted_40)) : _createCommentVNode("", true), _createElementVNode("line", {
          x1: d.x,
          y1: PLOT_Y1,
          x2: d.x,
          y2: PLOT_Y1 + 4,
          stroke: d.i === hoverIdx.value ? '#94a3b8' : '#e2e8f0',
          "stroke-width": "1"
        }, null, 8, _hoisted_41), _createElementVNode("text", {
          x: d.x,
          y: PLOT_Y1 + 18,
          "font-size": "10",
          fill: d.i === hoverIdx.value ? '#0f172a' : '#94a3b8',
          "text-anchor": "middle",
          "font-weight": "500",
          "font-variant-numeric": "tabular-nums"
        }, _toDisplayString(d.label), 9, _hoisted_42)]);
      }), 128)), mainAreaPath.value ? (_openBlock(), _createElementBlock("path", {
        key: 1,
        d: mainAreaPath.value,
        fill: "url(#r028MainFill)",
        opacity: mainLineHidden.value ? 0 : 1
      }, null, 8, _hoisted_43)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repoLines.value, l => {
        return _withDirectives((_openBlock(), _createElementBlock("g", {
          key: 'l' + l.code
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l.segments, (seg, si) => {
          return _openBlock(), _createElementBlock("polyline", {
            key: 's' + si,
            points: seg,
            stroke: l.color,
            "stroke-width": "1.2",
            fill: "none",
            "stroke-linejoin": "round",
            "stroke-linecap": "round",
            opacity: l.hidden ? 0 : 0.7
          }, null, 8, _hoisted_44);
        }), 128))])), [[_vShow, !l.isMain]]);
      }), 128)), mainLine.value && !mainLineHidden.value ? (_openBlock(), _createElementBlock("g", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainLine.value.segments, (seg, si) => {
        return _openBlock(), _createElementBlock("polyline", {
          key: 'ms' + si,
          points: seg,
          stroke: "url(#r028MainStroke)",
          "stroke-width": 2.4,
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round"
        }, null, 8, _hoisted_46);
      }), 128)), mainEnd.value ? (_openBlock(), _createElementBlock("g", _hoisted_47, [_createElementVNode("circle", {
        cx: mainEnd.value.x,
        cy: mainEnd.value.y,
        r: "4",
        fill: _unref(mainColor),
        stroke: "#fff",
        "stroke-width": "2"
      }, null, 8, _hoisted_48), _createElementVNode("circle", {
        cx: mainEnd.value.x,
        cy: mainEnd.value.y,
        r: "7",
        fill: _unref(mainColor),
        opacity: "0.18"
      }, null, 8, _hoisted_49), _createElementVNode("rect", {
        x: mainEnd.value.tagX,
        y: mainEnd.value.tagY,
        width: 62,
        height: "20",
        rx: "10",
        fill: _unref(mainColor)
      }, null, 8, _hoisted_50), _createElementVNode("text", {
        x: mainEnd.value.tagX + 31,
        y: mainEnd.value.tagY + 13.5,
        "font-size": "10.5",
        "font-weight": "700",
        fill: "#fff",
        "text-anchor": "middle",
        "font-variant-numeric": "tabular-nums"
      }, _toDisplayString(mainLatest.value.value) + "%", 9, _hoisted_51)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), indexLineSegments.value.length ? (_openBlock(), _createElementBlock("g", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indexLineSegments.value, (seg, si) => {
        return _openBlock(), _createElementBlock("polyline", {
          key: 'idx' + si,
          points: seg,
          stroke: INDEX_COLOR,
          "stroke-width": "1.8",
          fill: "none",
          "stroke-linejoin": "round",
          "stroke-linecap": "round",
          "stroke-dasharray": "5 2",
          opacity: "0.65"
        }, null, 8, _hoisted_53);
      }), 128))])) : _createCommentVNode("", true), hoverIdx.value >= 0 ? (_openBlock(), _createElementBlock("g", _hoisted_54, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoverDots.value, p => {
        return _openBlock(), _createElementBlock("circle", {
          key: 'hd' + p.code,
          cx: p.x,
          cy: p.y,
          r: "3.5",
          fill: p.isMain ? '#fff' : p.color,
          stroke: p.color,
          "stroke-width": "2"
        }, null, 8, _hoisted_55);
      }), 128))])) : _createCommentVNode("", true), hoverIdx.value >= 0 && hoverTip.value ? (_openBlock(), _createElementBlock("g", _hoisted_56, [_createElementVNode("rect", {
        x: hoverTip.value.x,
        y: hoverTip.value.y,
        width: hoverTip.value.w,
        height: hoverTip.value.h,
        rx: "8",
        fill: "#ffffff",
        stroke: "#e2e8f0",
        "stroke-width": "1"
      }, null, 8, _hoisted_57), _createElementVNode("text", {
        x: hoverTip.value.x + 12,
        y: hoverTip.value.y + 18,
        "font-size": "11",
        "font-weight": "700",
        fill: "#0f172a",
        "font-variant-numeric": "tabular-nums"
      }, _toDisplayString(hoverTip.value.date), 9, _hoisted_58), _createElementVNode("text", {
        x: hoverTip.value.x + hoverTip.value.w - 12,
        y: hoverTip.value.y + 18,
        "font-size": "10",
        "font-weight": "600",
        fill: "#94a3b8",
        "text-anchor": "end"
      }, "质押回购利率", 8, _hoisted_59), _createElementVNode("line", {
        x1: hoverTip.value.x + 12,
        y1: hoverTip.value.y + 24,
        x2: hoverTip.value.x + hoverTip.value.w - 12,
        y2: hoverTip.value.y + 24,
        stroke: "#f1f5f9",
        "stroke-width": "1"
      }, null, 8, _hoisted_60), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoverTip.value.rows, (row, ri) => {
        return _openBlock(), _createElementBlock("g", {
          key: 'hr' + ri
        }, [_createElementVNode("rect", {
          x: hoverTip.value.x + 12,
          y: hoverTip.value.y + 32 + ri * 16 - 4,
          width: "6",
          height: "6",
          rx: "1.5",
          fill: row.color
        }, null, 8, _hoisted_61), _createElementVNode("text", {
          x: hoverTip.value.x + 24,
          y: hoverTip.value.y + 34 + ri * 16,
          "font-size": "10.5",
          "font-weight": row.isMain ? 700 : 500,
          fill: row.isMain ? '#0f172a' : '#475569'
        }, _toDisplayString(row.code), 9, _hoisted_62), _createElementVNode("text", {
          x: hoverTip.value.x + hoverTip.value.w - 12,
          y: hoverTip.value.y + 34 + ri * 16,
          "font-size": "10.5",
          "font-weight": row.isMain ? 700 : 500,
          fill: row.isMain ? row.color : '#0f172a',
          "text-anchor": "end",
          "font-variant-numeric": "tabular-nums"
        }, _toDisplayString(row.value), 9, _hoisted_63)]);
      }), 128))])) : _createCommentVNode("", true)], 40, _hoisted_29))]), _createElementVNode("div", _hoisted_64, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repoLines.value, l => {
        return _openBlock(), _createElementBlock("button", {
          key: 'leg' + l.code,
          class: _normalizeClass(["gs-r028__leg-item", {
            'gs-r028__leg-item--off': l.hidden,
            'gs-r028__leg-item--main': l.isMain && !l.hidden && !isOnlyMain.value,
            'gs-r028__leg-item--solo': l.isMain && isOnlyMain.value,
            'gs-r028__leg-item--only': l.isOnly
          }]),
          onClick: $event => onLegClick(l.code, $event),
          title: '单击切换 · 双击只看 ' + l.code
        }, [_createElementVNode("i", {
          style: _normalizeStyle({
            background: l.color
          })
        }, null, 4), _createElementVNode("span", _hoisted_66, _toDisplayString(l.code), 1), _createElementVNode("span", _hoisted_67, _toDisplayString(l.lastText), 1)], 10, _hoisted_65);
      }), 128)), _cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "gs-r028__leg-sep"
      }, null, -1)), _createElementVNode("span", {
        class: "gs-r028__leg-item gs-r028__leg-item--idx",
        title: '上证指数 ' + indexLatest.value
      }, [_cache[11] || (_cache[11] = _createElementVNode("i", {
        style: {
          "background": "#0f172a"
        }
      }, null, -1)), _cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "gs-r028__leg-name"
      }, "上证", -1)), _createElementVNode("span", _hoisted_69, _toDisplayString(indexLatest.value), 1)], 8, _hoisted_68)])]))])]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chapters, ch => {
        return _createElementVNode("section", {
          key: ch.id,
          class: "gs-card",
          style: _normalizeStyle({
            '--accent': ch.accent
          })
        }, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("h3", _hoisted_72, [_createTextVNode(_toDisplayString(ch.title) + " ", 1), _createElementVNode("span", _hoisted_73, _toDisplayString(ch.subtitle), 1)])]), _createElementVNode("span", _hoisted_74, _toDisplayString(stockData[ch.id].length), 1)]), _createElementVNode("div", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ch.tags, t => {
          return _openBlock(), _createElementBlock("button", {
            key: t.label,
            class: _normalizeClass(["gs-tag", {
              'gs-tag--active': activeTag.value[ch.id] === t.label,
              'gs-tag--buy': t.type === 'buy',
              'gs-tag--sell': t.type === 'sell',
              'gs-tag--warn': t.type === 'warn',
              'gs-tag--neutral': t.type === 'neutral'
            }]),
            onClick: $event => activeTag.value[ch.id] = t.label
          }, _toDisplayString(t.label), 11, _hoisted_76);
        }), 128))]), _createElementVNode("div", _hoisted_77, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStocks(ch.id), (s, i) => {
          return _openBlock(), _createElementBlock("div", {
            key: s.code,
            class: "gs-stock",
            onClick: $event => openDrawer(s.name, s.code, s.price, s.change, s.dir, s.form, s.match)
          }, [_createElementVNode("span", {
            class: _normalizeClass(["gs-stock__rank", {
              'gs-stock__rank--1': i === 0,
              'gs-stock__rank--2': i === 1,
              'gs-stock__rank--3': i === 2
            }])
          }, _toDisplayString(i + 1), 3), _createElementVNode("span", {
            class: _normalizeClass(["gs-stock__indicator", 'gs-ind--' + s.dir])
          }, null, 2), _createElementVNode("span", _hoisted_79, _toDisplayString(s.name), 1), _createElementVNode("span", _hoisted_80, _toDisplayString(s.code), 1), _createElementVNode("span", _hoisted_81, _toDisplayString(s.price), 1), _createElementVNode("span", {
            class: _normalizeClass(["gs-stock__change", 'gs-' + s.dir])
          }, _toDisplayString(s.change), 3), _createElementVNode("span", _hoisted_82, _toDisplayString(s.form), 1)], 8, _hoisted_78);
        }), 128))]), _createElementVNode("div", _hoisted_83, " 共 " + _toDisplayString(stockData[ch.id].length) + " 只匹配 · 每 60s 更新 ", 1)], 4);
      }), 64))]), _createElementVNode("div", {
        class: _normalizeClass(["gs-drawer-bg", {
          'gs-drawer-bg--open': drawerOpen.value
        }]),
        onClick: closeDrawer
      }, null, 2), _createElementVNode("aside", {
        class: _normalizeClass(["gs-drawer", {
          'gs-drawer--open': drawerOpen.value
        }])
      }, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", null, [_createElementVNode("strong", _hoisted_85, _toDisplayString(drawerData.value.name), 1), _createElementVNode("span", _hoisted_86, _toDisplayString(drawerData.value.code), 1)]), _createElementVNode("button", {
        class: "gs-drawer__close",
        onClick: closeDrawer
      }, "×")]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("b", null, _toDisplayString(drawerData.value.price), 1), _createElementVNode("span", {
        class: _normalizeClass('gs-' + drawerData.value.direction)
      }, _toDisplayString(drawerData.value.change), 3), _createElementVNode("em", _hoisted_89, "匹配 " + _toDisplayString(drawerData.value.match) + "%", 1)]), _createElementVNode("span", _hoisted_90, _toDisplayString(drawerData.value.signal), 1), _createElementVNode("div", _hoisted_91, [_cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "gs-drawer__section-title"
      }, "交易计划", -1)), _createElementVNode("div", _hoisted_92, [_cache[14] || (_cache[14] = _createElementVNode("span", null, "建仓区间", -1)), _createElementVNode("span", null, _toDisplayString(drawerData.value.price) + " 附近", 1)]), _createElementVNode("div", _hoisted_93, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "止损位", -1)), _createElementVNode("span", _hoisted_94, _toDisplayString((parseFloat(drawerData.value.price) * 0.95).toFixed(2)), 1)]), _createElementVNode("div", _hoisted_95, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "目标位", -1)), _createElementVNode("span", _hoisted_96, _toDisplayString((parseFloat(drawerData.value.price) * 1.08).toFixed(2)), 1)])]), _createElementVNode("div", _hoisted_97, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "gs-drawer__section-title"
      }, "K线 + 成交量 + 四季均线", -1)), _createElementVNode("div", _hoisted_98, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(candleTypes, (c, i) => {
        return _createElementVNode("div", {
          key: i,
          class: _normalizeClass(["gs-candle", 'gs-candle--' + c.cls])
        }, [_createElementVNode("div", {
          class: "gs-candle__body",
          style: _normalizeStyle({
            height: c.body + 'px'
          })
        }, null, 4)], 2);
      }), 64))])]), _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"gs-drawer__season\" data-v-7357457c><div class=\"gs-drawer__section-title\" data-v-7357457c>四季均线状态</div><div class=\"gs-drawer__season-grid\" data-v-7357457c><div class=\"gs-season gs-season--sp\" data-v-7357457c><em data-v-7357457c>春·MA5</em><b data-v-7357457c>12.20</b><span class=\"gs-up\" data-v-7357457c>多头</span></div><div class=\"gs-season gs-season--su\" data-v-7357457c><em data-v-7357457c>夏·MA10</em><b data-v-7357457c>11.85</b><span class=\"gs-up\" data-v-7357457c>多头</span></div><div class=\"gs-season gs-season--au\" data-v-7357457c><em data-v-7357457c>秋·MA20</em><b data-v-7357457c>11.50</b><span class=\"gs-up\" data-v-7357457c>多头</span></div><div class=\"gs-season gs-season--wi\" data-v-7357457c><em data-v-7357457c>冬·MA60</em><b data-v-7357457c>10.80</b><span class=\"gs-up\" data-v-7357457c>多头</span></div></div></div>", 1)), _createElementVNode("div", _hoisted_99, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "gs-drawer__section-title"
      }, "识别依据", -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(drawerBasis, (item, i) => {
        return _createElementVNode("div", {
          class: "gs-drawer__basis-item",
          key: i
        }, [_cache[19] || (_cache[19] = _createElementVNode("span", null, "✓", -1)), _createElementVNode("span", {
          innerHTML: item
        }, null, 8, _hoisted_100)]);
      }), 64))])])], 2)]);
    };
  }
};